















































import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { FullPriceData } from "@/lib/moneyHelpers";
import { ContentFeedPurchaseEvent } from "@/types";
import { PurchaseType } from "@/const";
import BaseButton from "@/components/BaseButton";
import PaymentConfirmation from "@/components/PaymentConfirmation";
import UserSubscribeModal from "@/components/UserSubscribeModal";

export default defineComponent({
  name: "UnlockFeedView",
  components: { PaymentConfirmation, UserSubscribeModal, BaseButton },
  props: {
    selectedFeed: { type: Object as () => ContentFeed, required: true },
    priceData: { type: Object as PropType<FullPriceData>, required: true },
    purchaseProcessing: { type: Boolean, required: true },
    typeOfPurchase: { type: Object as () => Omit<ContentFeedPurchaseEvent, "feed"> },
  },
  setup(props, { emit }) {
    const openPaymentConfirm = ref(false);
    const isOnlyPrice = computed(() => {
      return (
        props.typeOfPurchase?.oneTimePurchase ||
        (props.selectedFeed.subscriptionLevelId === "0" && props.selectedFeed.pricePackageId !== "0")
      );
    });
    const isOnlySubscription = computed(() => !!props.typeOfPurchase && props.typeOfPurchase.subscription);
    const showUnlockButton = computed(() => !isOnlySubscription.value && !!props.priceData.cost);
    const showPaymentConfirmation = computed(() => isOnlyPrice.value || openPaymentConfirm.value);

    const onClose = () => {
      if (props.purchaseProcessing) return;
      if (isOnlyPrice.value) {
        emit("close");
      }
      openPaymentConfirm.value = false;
    };

    return {
      isOnlyPrice,
      showPaymentConfirmation,
      openPaymentConfirm,
      showUnlockButton,
      PurchaseType,
      onClose,
    };
  },
});
